import { useScopedQuery } from '@frontend/scope';
import { AudioScrubber } from '@frontend/design-system';

export const CachedAudioScrubber = ({
  onPlay,
  filePath,
  mediaId,
  trackingId = 'cached-audioScrubber',
  queryFn,
  isCompactMode,
}: {
  onPlay?: () => void;
  filePath?: string;
  mediaId: string;
  trackingId?: string;
  queryFn?: () => Promise<Response>;
  isCompactMode?: boolean;
}) => {
  /**
   * Why fetch the resource instead of loading it directly into the audio component?
   *
   * Doing this allows us to cache the resource, so that the audio component doesn't re-fetch it every time it's rendered.
   */
  const { data } = useScopedQuery({
    queryKey: ['phone-media', mediaId],
    queryFn: async () => {
      let response;
      try {
        if (queryFn) {
          response = await queryFn();
        } else if (filePath) {
          response = await fetch(filePath);
        } else {
          return undefined;
        }

        return response.blob().then((myBlob) => {
          const objectURL = URL.createObjectURL(myBlob);
          return objectURL;
        });
      } catch (error) {
        console.error('Error fetching audio blob:', error);

        return undefined;
      }
    },
    enabled: !!mediaId,
    staleTime: Infinity,
  });

  return data ? (
    <AudioScrubber
      trackingId={trackingId}
      autoSize
      onPlay={onPlay}
      singlePlayer
      src={data}
      isCompactMode={isCompactMode}
      css={{ maxWidth: '100%' }}
    />
  ) : null;
};
